<template>
  <div class="card card-custom gutter-b">
    <div class="card-header border-0">
      <h3 data-v-1ceb636c="" class="card-title font-weight-bolder">
        Campaigns
      </h3>
    </div>
    <!--begin::Body-->
    <div class="card-body d-flex flex-column py-0">
      <div
        class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded"
      >
        <v-data-table
          :headers="translatedColumns"
          :items="getItems"
          item-key="Traffic Source"
          :server-items-length="pagesAmount * rowsAmount"
          hide-default-footer
          :options.sync="options"
          :page.sync="page"
          :loading="loading"
          class="text-no-wrap"
        >
          <template v-slot:item="{ item }">
            <tr :class="'level-' + item.level">
              <td v-for="(columnName, i) in availableColumns" :key="i">
                <span v-if="typeof item[columnName] == 'object'">
                  <a href="#" v-on:click="getExpand(item, columnName)">{{
                    item[columnName].count + " tags"
                  }}</a>
                </span>
                <span v-else>{{ item[columnName] }}</span>
              </td>
            </tr>
          </template>
          <template v-slot:footer="">
            <v-row justify="end" align="center">
              <v-col cols="auto" class="mr-auto">
                <v-container>
                  <v-btn
                    :disabled="options.page === 1"
                    elevation="0"
                    icon
                    @click.stop="options.page = 1"
                  >
                    <v-icon>mdi-arrow-collapse-left</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="options.page === 1"
                    elevation="0"
                    icon
                    @click.stop="options.page--"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  {{ options.page }} / {{ pagesAmount }}
                  <v-btn
                    :disabled="options.page === pagesAmount"
                    elevation="0"
                    icon
                    @click.stop="options.page++"
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="options.page === pagesAmount"
                    elevation="0"
                    icon
                    @click.stop="options.page = pagesAmount"
                  >
                    <v-icon>mdi-arrow-collapse-right</v-icon>
                  </v-btn>
                </v-container>
              </v-col>
              <v-col cols="auto">
                <v-container>
                  <v-text-field
                    :value="options.page"
                    label="Page"
                    type="number"
                    min="1"
                    :max="pagesAmount"
                    @input="toPage($event)"
                  ></v-text-field>
                </v-container>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignsTable",
  props: {
    dates: {
      type: Array,
      required: true
    },
    selectedDomains: {
      type: Array,
      required: true
    },
    status: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      expanded: [],
      text_exp: [],
      expandedTable: [],
      disabledSwitchers: [],
      loadingSwitchers: [],
      clicksIds: [],
      gclidDialog: false,
      detailsDialog: false,
      row: {},
      loading: false,
      searchQuery: "",
      searchColumn: null,
      rowsAmount: 10,
      sortColumn: null,
      sortDirection: null,
      excelUrl: "",
      page: 1,
      pagesAmount: 1,
      searchColumns: null,
      selectedColumns: [],
      availableColumns: null,
      table: null,
      rows: [10, 25, 50, 100],
      timestamp: 0,
      options: {},
      group: {},
      level: 1
    };
  },
  computed: {
    icon() {
      if (!this.table) return "";
      if (this.availableColumns.length === this.selectedColumns.length)
        return "mdi-checkbox-marked";
      if (this.availableColumns.length !== this.selectedColumns.length)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    translatedColumns() {
      return this.availableColumns?.map(el => ({
        text: this.$t("analytics.campaigns.tableTags." + el),
        value: el
      }));
    },
    getItems() {
      return this.table || [];
    }
  },
  watch: {
    options: {
      async handler() {
        await this.getTableData();
      }
    },
    async dates() {
      await this.getTableData();
    },
    async selectedDomains() {
      await this.getTableData();
    },
    async status() {
      await this.getTableData();
    }
  },
  methods: {
    async getExpand(item, columnName) {
      if (item.opened) {
        // удаляем детей
        this.table = this.table.filter(function(tableItem) {
          return !(tableItem.parentID && tableItem.parentID.includes(item.id));
        });
        item.opened = false;
        return;
      }

      let afterIndex = 0;
      let level = 0;
      let group = {};
      this.table.forEach(function(tableItem, tableItemIndex) {
        if (tableItem.id === item.id) {
          afterIndex = tableItemIndex;
        }
      });
      let names = [
        "SourceId",
        "UtmSource",
        "UtmCampaign",
        "UtmMedium",
        "UtmTerm",
        "UtmContent"
      ];
      names.forEach(name => {
        if (typeof item[name] !== "object" && item[name] !== "–") {
          group[name] = item[name];
          level++;
        }
      });
      group[columnName] = null;

      this.expanded = [];
      this.text_exp.push(columnName);
      this.expanded.push(item);

      const { table } = await this.$api.analyticsCampaigns.getCampaignsTable({
        dateFrom: this.dates[0],
        dateTo: this.dates[1] ?? this.dates[0],
        domains: this.selectedDomains.map(el => el.id),
        searchColumn: this.searchColumn,
        selectedColumns: this.selectedColumns,
        tableName: "campaignsFraudBlocking",
        group: group,
        level: level
      });

      table.forEach(tableItem => {
        let parentId = item.parentID;

        if (typeof parentId === "string") {
          tableItem.parentID = [parentId];
        } else if (typeof parentId === "object") {
          tableItem.parentID = parentId;
        } else {
          tableItem.parentID = [];
        }

        tableItem.parentID.push(item.id);

        this.table.splice(afterIndex + 1, 0, tableItem);
      });

      item.opened = true;

      this.expandedTable = table;
    },
    disabledSwitcher(item) {
      return this.disabledSwitchers.find(switcher => item.id === switcher);
    },
    loadingSwitcher(item) {
      return this.loadingSwitchers.find(switcher => item.id === switcher)
        ? "warning"
        : null;
    },
    async showGlids(item) {
      this.row = item;
      this.gclidDialog = true;
      try {
        const { clicks } = await this.$api.analyticsBlocking.getClicksIDs({
          detectId: item.id,
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id)
        });
        this.clicksIds = clicks;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      }
    },
    async getTableData() {
      this.loading = true;
      if (!this.page) {
        this.page = 1;
      }
      try {
        const {
          excelUrl,
          page,
          pagesAmount,
          searchColumns,
          visibleColumns,
          availableColumns,
          table,
          timestamp
        } = await this.$api.analyticsCampaigns.getCampaignsTable({
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id),
          searchColumn: this.searchColumn,
          selectedColumns: this.selectedColumns,
          tableName: "campaignsFraudBlocking",
          group: this.group
        });
        if (timestamp > this.timestamp) {
          this.excelUrl = excelUrl;
          this.page = page;
          this.pagesAmount = pagesAmount;
          this.searchColumns = searchColumns;
          this.selectedColumns = visibleColumns;
          this.availableColumns = availableColumns;
          this.table = table;
          this.timestamp = timestamp;
        }
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async selectAllColumns() {
      if (this.selectedColumns.length === this.availableColumns.length) {
        this.selectedColumns = [];
      } else {
        this.selectedColumns = this.availableColumns;
      }
      await this.getTableData();
    },
    async setSorting(columnName) {
      if (columnName !== this.sortColumn) {
        this.sortColumn = columnName;
        this.sortDirection = null;
      }
      if (this.sortDirection) {
        if (this.sortDirection === "desc") {
          this.sortDirection = "asc";
        } else {
          this.sortColumn = null;
          this.sortDirection = null;
        }
      } else {
        this.sortDirection = "desc";
      }
      await this.getTableData();
    },
    toPage(event) {
      let page = parseInt(event, 10);
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagesAmount) {
        page = this.pagesAmount;
      }
      this.options.page = page;
    },
    getFirstSuspicion(item) {
      return item.suspicion.find(el => !!el).title;
    }
  }
};
</script>

<style scoped>
.level-1 {
  background-color: #fafafa !important;
}
.level-2 {
  background-color: #f0f0f0 !important;
}
.level-3 {
  background-color: #e5e5e5 !important;
}
.level-4 {
  background-color: #dddddd !important;
}
.v-progress-linear__background {
  background: #1867c0 !important;
}
.v-progress-linear__indeterminate {
  background: #1867c0 !important;
}
</style>
